module.exports = __webpack_public_path__ + "static/media/mfrid.f4920253.PNG";